{
    angular.module('interfaceModule')
        .controller('HeaderController',HeaderController);
    HeaderController.$inject = ['$scope',"utils.currentUser",'utils.constant','$state','utils.platform','request.order'];
    function HeaderController($scope,currentUser,constant,$state,platform,orderRequest) {
        let vm=this;
        let collect={
            'activate':activate,
            'userInfo':null,
            linkUseProcess:linkUseProcess,
            'logout':logout,
            'setarealist':setarealist,
            'arealist':[],
            'userareaname':'',
            //新添加
            'tabClick': tabClick,
            "isMobile":false,
        };
        vm.collect=collect;
        activate();

        function activate(){
            // currentUser.getUserInfo()
            // .then(function(resData){console.log(resData);
            //     collect.userInfo=resData.userInfo;
            // });
            collect.isMobile=platform.isIOS()||platform.isAndroid();
            console.log('机器设备',collect.isMobile);
            if(currentUser.info){
                collect.userInfo=currentUser.info;
                collect.userareaname = collect.userInfo.areaname;

                if (collect.userareaname != null)
                {
                    if (collect.userareaname.length <= 0)
                    {
                        collect.userareaname = "请选择打印点";
                    }
                }
                else
                {
                    collect.userareaname = "请选择打印点";
                }

                if (collect.isMobile == true)
                {
                    if (collect.userareaname.length > 8)
                    {
                        collect.userareaname = collect.userareaname.substring(0, 8);
                    }
                }

                //console.log('头部当前用户信息', collect.userInfo);
            }else{
                $scope.$on('user.logged',function(event,data){
                   // console.log('头部监听用户信息user.logged');
                    //console.log('user.logged',data);
                    collect.userInfo=data;

                    collect.userareaname = collect.userInfo.areaname;

                    if (collect.userareaname != null)
                    {
                        if (collect.userareaname.length <= 0)
                        {
                            collect.userareaname = "请选择打印点";
                        }
                    }
                    else
                    {
                        collect.userareaname = "请选择打印点";
                    }

                    if (collect.isMobile == true)
                    {
                        if (collect.userareaname.length > 8)
                        {
                            collect.userareaname = collect.userareaname.substring(0, 8);
                        }
                    }

                    $scope.userinfo=data;
                })
            }
            var rechargeInfo =JSON.parse(sessionStorage.getItem("rechargeInfo")) ;
            if(rechargeInfo){
               // console.log("确保充值成功");
                //console.log(rechargeInfo);
                orderRequest.setRechargeInfo(rechargeInfo.userId,rechargeInfo.amount,rechargeInfo.paytype,rechargeInfo.orderId,rechargeInfo.payAction)
                    .then(function (data) {
                        if(data[0].result == 1){
                            sessionStorage.removeItem('rechargeInfo');
                        }
                    })
            }

            collect.arealist=[];

            orderRequest.getAreaList()
                .then(function (data)
                {
                    if(data.result == 1)
                    {
                        collect.arealist=data;

                        console.log("getAreaList result:");
                        console.log(data);
                    }
                })
        }

        function logout(){
            currentUser.logout();
        }
        function linkUseProcess() {
            $state.go('useProcess');
        }

        function setarealist(areaid,areaname){
            console.log("setarealist:" + areaid);
            console.log("setarealist:" + collect.userInfo.userId);

            collect.userInfo.areaid = areaid;
            collect.userInfo.areaname = areaname;

            collect.userareaname = areaname;

            if (collect.userareaname != null)
            {
                if (collect.userareaname.length <= 0)
                {
                    collect.userareaname = "请选择打印点";
                }
            }
            else
            {
                collect.userareaname = "请选择打印点";
            }

            if (collect.isMobile == true)
            {
                if (collect.userareaname.length > 8)
                {
                    collect.userareaname = collect.userareaname.substring(0, 8);
                }
            }

            currentUser.areaid = areaid;
            currentUser.areaname = areaname;

            orderRequest.setAreaList(areaid,collect.userInfo.userId)
                .then(function (data)
                {
                    if(data.result == 1)
                    {
                        console.log("setAreaList result:");
                        console.log(data);
                    }
                })
        }

        function tabClick(type){
            if(type == 1){
                $state.go('main.company',{'userId':collect.userInfo.userId});
            }else if(type == 2){
                $state.go('main.partner',{'userId':collect.userInfo.userId});
            }
        }

    }
    
}